<template>
  <div>
    <div class="uk-section-default">
      <div
        class="uk-section uk-light uk-background-cover"
        style="background-image: linear-gradient(180deg,rgba(22, 36, 56, 0.5),rgb(1 7 14 / 68%)),url(https://unsplash.com/photos/nfQk1YdGoNc/download?force=true&w=1920);"
      >
        <div class="uk-container white-text">
          <h1>Intermodal Dispatch Software</h1>

          <p class="uk-text-large">
            <strong>contrak</strong> is a Drayage Operations System that is
            focused on automation. Automatically track containers, manage
            orders, dispatch, bill, and keep your customers updated.
            <br />
          </p>
          <a
            class="uk-button uk-button-primary uk-button-large"
            href="/tracking"
            >Try Contrak now</a
          >
        </div>
      </div>
    </div>
    <div
      class="uk-section uk-section-n uk-padding-remove-bottom uk-padding-remove-top"
    >
      <div class="uk-section uk-section-storm">
        <h2>Automated Container Tracking</h2>
        <div class="uk-container uk-margin-bottom">
          <img src="@/assets/containers.png"  />
        </div>
        <div class="uk-container">
          <div uk-grid class="uk-grid-small">
            <div class="uk-width-1-3 uk-text-left">
              <span
                uk-icon="icon: world; ratio: 1.5"
                class="uk-margin-remove"
              ></span>
              <!-- </h4> -->
              <p
                class="uk-margin-small-bottom uk-margin-small-top"
                style="color: white"
              >
                <strong>Track your containers in one place</strong>
              </p>
              <p class="uk-margin-small-top">
                Keep track of your containers, link them to customers, and trace
                accross ETS, OICT and TraPac.
              </p>
            </div>
            <div class="uk-width-1-3 uk-text-left">
              <span
                uk-icon="icon: bolt; ratio: 1.5"
                class="uk-margin-remove"
              ></span>
              <!-- </h4> -->
              <p
                class="uk-margin-small-bottom uk-margin-small-top"
                style="color: white"
              >
                <strong>Easy to use</strong>
              </p>
              <p class="uk-margin-small-top">
                Enter a Bill of Lading or a container number, Contrak will find
                the size, type, vessel, holds and yard information.
              </p>
            </div>
            <div class="uk-width-1-3 uk-text-left">
              <span
                uk-icon="icon: mail; ratio: 1.5"
                class="uk-margin-remove"
              ></span>
              <!-- </h4> -->
              <p
                class="uk-margin-small-bottom uk-margin-small-top"
                style="color: white"
              >
                <strong>Email Updates</strong>
              </p>
              <p class="uk-margin-small-top">
                Contrak automatically updates all of your containers every hour.
                Get notified when containers become available, LFDs are added,
                or when demurrage is incurred.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="uk-section uk-section-default uk-light"
        style="background-color: black"
      >
        <h2>Manage Orders in one place</h2>

        <div class="uk-container">
          <div uk-grid class="uk-grid-small">
            <div class="uk-container uk-width-3-5">
              <img src="@/assets/order_details.png"  />
            </div>
            <div class="uk-width-2-5">
              <div uk-grid>
                <div>
                  <span
                    uk-icon="icon: nut; ratio: 1.5"
                    class="uk-margin-remove"
                  ></span>
                  <p
                    class="uk-margin-small-bottom uk-margin-small-top"
                    style="color: white"
                  >
                    <strong>Manage orders and dispatch</strong>
                  </p>
                  <p class="uk-margin-small-top">
                    Easily create orders from your tracked containers, view all
                    containers by customer, and dispatch drivers all from one
                    place.
                  </p>
                </div>
                <div>
                  <span
                    uk-icon="icon: print; ratio: 1.5"
                    class="uk-margin-remove"
                  ></span>
                  <p
                    class="uk-margin-small-bottom uk-margin-small-top"
                    style="color: white"
                  >
                    <strong>Automatically Generate Paperwork</strong>
                  </p>
                  <p class="uk-margin-small-top">
                    Add an order to a container, enter the drop-off and pick-up
                    location and let Contrak generate your Cover Sheets, Bill of
                    Lading and Driver Delivery Instructions Automatically
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-section uk-section-storm uk-light">
        <h2>Dispatch at the speed of thought</h2>
        <div class="uk-container uk-margin-bottom">
          <img src="@/assets/dispatch_details.png"  />
        </div>
        <div class="uk-container">
          <div uk-grid class="uk-grid-small">
            <div class="uk-width-1-3 uk-text-left">
              <span
                uk-icon="icon: settings; ratio: 1.5"
                class="uk-margin-remove"
              ></span>
              <!-- </h4> -->
              <p
                class="uk-margin-small-bottom uk-margin-small-top"
                style="color: white"
              >
                <strong>Flexible Dispatch</strong>
              </p>
              <p class="uk-margin-small-top">
                View your moves, and dispatch moves by Move type, by Order, by
                Container or by Driver.
              </p>
            </div>
            <div class="uk-width-1-3 uk-text-left">
              <span
                uk-icon="icon: calendar; ratio: 1.5"
                class="uk-margin-remove"
              ></span>
              <!-- </h4> -->
              <p
                class="uk-margin-small-bottom uk-margin-small-top"
                style="color: white"
              >
                <strong>Advanced Scheduling</strong>
              </p>
              <p class="uk-margin-small-top">
                Plan your moves in advance, and dispatch for today, tomorrow or
                day after.
              </p>
            </div>
            <div class="uk-width-1-3 uk-text-left">
              <span
                uk-icon="icon: clock; ratio: 1.5"
                class="uk-margin-remove"
              ></span>
              <!-- </h4> -->
              <p
                class="uk-margin-small-bottom uk-margin-small-top"
                style="color: white"
              >
                <strong>Appointments</strong>
              </p>
              <p class="uk-margin-small-top">
                Keep track of your terminal and delivery appointments while
                you're dispatching
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        class="uk-section uk-section-default uk-light"
        style="background-color: black"
      >
        <h2>Customer Portal</h2>

        <div class="uk-container">
          <div uk-grid class="uk-grid-small">
            <div class="uk-width-2-5 uk-margin-">
              <div uk-grid>
                <div class="uk-margin-right">
                  <span
                    uk-icon="icon: grid; ratio: 1.5"
                    class="uk-margin-remove"
                  ></span>
                  <p
                    class="uk-margin-small-bottom uk-margin-small-top"
                    style="color: white"
                  >
                    <strong
                      >Easily share work order status with customers</strong
                    >
                  </p>
                  <p class="uk-margin-small-top">
                    Wow your customers and elimate phone calls by enabling them
                    to track their order status, container info and
                    appointments.
                  </p>
                </div>
              </div>
            </div>
            <div class="uk-container uk-width-3-5">
              <img
                class="uk-margin-left"
                src="@/assets/customer_portal.png"
                
              />
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="uk-section uk-section-storm uk-light">
        <h2>Customer Portal</h2>
        <div class="uk-container uk-margin-bottom">
          <img src="@/assets/dispatch_details.png" alt />
        </div>
        <div class="uk-container">
          <div uk-grid class="uk-grid-small">
            <div class="uk-width-1-3 uk-text-left">
              <span
                uk-icon="icon: settings; ratio: 1.5"
                class="uk-margin-remove"
              ></span>
              <p
                class="uk-margin-small-bottom uk-margin-small-top"
                style="color: white"
              >
                <strong>Flexible Dispatch</strong>
              </p>
              <p class="uk-margin-small-top">
                View your moves, and dispatch moves by Move type, by Order, by
                Container or by Driver.
              </p>
            </div>
            <div class="uk-width-1-3 uk-text-left">
              <span
                uk-icon="icon: calendar; ratio: 1.5"
                class="uk-margin-remove"
              ></span>
              <p
                class="uk-margin-small-bottom uk-margin-small-top"
                style="color: white"
              >
                <strong>Advanced Scheduling</strong>
              </p>
              <p class="uk-margin-small-top">
                Plan your moves in advance, and dispatch for today, tomorrow or
                day after.
              </p>
            </div>
            <div class="uk-width-1-3 uk-text-left">
              <span
                uk-icon="icon: clock; ratio: 1.5"
                class="uk-margin-remove"
              ></span>
              <p
                class="uk-margin-small-bottom uk-margin-small-top"
                style="color: white"
              >
                <strong>Appointments</strong>
              </p>
              <p class="uk-margin-small-top">
                Keep track of your terminal and delivery appointments while
                you're dispatching
              </p>
            </div>
          </div>
        </div>
      </div> -->
      <div class="uk-section uk-section-primary">
        <h2>
          Reduce data entry, phone calls and paperwork. Streamline your
          operations with a modern Drayage Operations System.
        </h2>
        <a class="uk-button uk-button-primary uk-button-large" href="/login"
          >Sign up for Contrak</a
        >
      </div>
    </div>
    <div class="uk-section uk-section-secondary">
      <div class="uk-container">
        <div class="uk-grid-match uk-child-width-1-2" uk-grid>
          <div>
            <b>About</b>
            <p>
              Contrak is an intelligent dispatch management system for
              intermodal drayage.
            </p>
            <p>Developed in Oakland, CA</p>
          </div>
          <div>
            <b>Contact us</b>
            <p>
              Want to learn more about how to upgrade your dispatch operations?
              Send us a note:
            </p>
            <p>hi@contrak.us</p>
          </div>
        </div>
      </div>

      <!-- <P>Developed in Oakland, CA</P>
      <p>Contact: contrak@convergeautomation.com</p>-->
    </div>
    <h3></h3>
  </div>
</template>


<style>
.white-text {
  color: white;
}
</style>
